import React, { useEffect, useMemo, useState } from 'react';
import { Layout, Card, Button, Input, Radio, Collapse, Space, Form, DatePicker, Popconfirm, message } from 'antd';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useSelector } from 'react-redux';
import CustomThemeDrawer from '../../../../../Elements/CustomThemeDrawer';
import { APIConstants } from '../../../../../../Common/APIConstants';
import { EditOutlined, DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';

const { Content } = Layout
const { Panel } = Collapse;
const { RangePicker } = DatePicker;
// import dayjs from "dayjs";
const MAX_DAYS = 90;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';
import { useStoreUpdaterWithAPI } from '../../../../../../Hooks/UseStoreUpdaterWithApi';
import { generatedISOFormatDateString } from '../../../../../../Utils/DateConverstion';

// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);

const ManuallyEnteredData = () => {
    const [open, setOpen] = useState(false); 
    const [open2, setOpen2] = useState(false); 
    const { makeRequest } = useStoreUpdaterWithAPI(); 
    const [refetch,setRefetch] = useState(false);
    const [row, setRow] = useState([])
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [rowEntry, setRowEntry] = useState([]);
    
    const [value,setValue]=useState([dayjs().add(-7, 'd'), dayjs()]);
    const [dates,setDates]=useState([value[0]?.format("YYYY-MM-DD HH:mm:ss"),value[1]?.format("YYYY-MM-DD HH:mm:ss")]);
    const [isPanel1Complete, setIsPanel1Complete] = useState(false);
    const [isPanel2Complete, setIsPanel2Complete] = useState(false);
    const [isPanel3Complete, setIsPanel3Complete] = useState(false);
    const [isPanel4Complete, setIsPanel4Complete] = useState(false);
      const [externalEnergySources, setExternalEnergySources] = useState([]);
  const [productionData, setProductionData] = useState([]);
  const [resourceDetails, setResourceDetails] = useState([]);
    const showDrawer = () => {
        setOpen(true);
      };
    
      const onClose = () => {
        setOpen(false);
      };
    const showDrawer2 = () => {
        setOpen2(true);
      };

      
    
      const onClose2 = () => {
        setOpen2(false);
      };
      const handleClear = () => {
        form.resetFields();
        onClose() 
        
      };
      const deleteManualEntry = (data) => {
          console.log(formatDateISOWithPadding(data.date));
          makeRequest({
            type: APIConstants.DELETE,
            url: `${APIConstants.DELETE_MANUAL_ENTRY}?Date=${formatDateISOWithPadding(data?.date)}`,
          }).then((res) => {
            console.log("Master details :", res);
            setRefetch(!refetch);
            if (res && res.length > 0) {
              // setFlowSectionList(res);
            }
          });
        };

    const mode = useSelector((state) => state.darkMode);
const color = useSelector((state) => state.ThemeChange);
console.log(color);
const { isdarkMode } = mode;
  const handleNotification = (msg, type) => {
    message.open({
      content: `${msg}`,
      type: type,
    });
  };
  

  const externalEnergySourceColumns = externalEnergySources
  .filter(source => source?.isActive)
  .map(source => ({
    headerName: source?.sourceName,
    field: source?.sourceName.toLowerCase().replace(/\s+/g, '_'), // e.g., "New Solar" → "new_solar"
    width: 120,
    flex: 1
  }));
  console.log(productionData)
  console.log(resourceDetails)
  console.log(externalEnergySourceColumns)
  const productionColumns = productionData
  .filter(source => source?.isActive)
  .map(source => ({
    headerName: source?.productionDataName,
    field: source?.productionDataName.toLowerCase().replace(/\s+/g, '_'), // e.g., "New Solar" → "new_solar"
    width: 120,
    flex: 1
  }));
  const emissionColumns = resourceDetails
  .filter(source => source?.isActive)
  .map(source => ({
    headerName: source?.emissionDetailName,
    field: source?.emissionDetailName.toLowerCase().replace(/\s+/g, '_'), // e.g., "New Solar" → "new_solar"
    width: 120,
    flex: 1
  }));
const columnDefs = [
    { headerName: 'Date', field: 'date', width: 150, pinned: 'left', flex:1 },
  
    {
      headerName: 'External Energy Sources',
      children:externalEnergySourceColumns
    },
  
    {
      headerName: 'Production Data',
      children: productionColumns
    },
  
    {
      headerName: 'Resource Details',
      children: emissionColumns,
    },
    {
      headerName: "Actions",
      width: 150,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2" >
            {/* <Button
            //   onClick={() => { 
            //     params.data.actions.update(params.data);
            //   }}
            >
              <EditOutlined />
            </Button> */}

            {/* <Popconfirm
              title="Are you sure to delete this Converter"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteManualEntry(params.data)}
              trigger="click"
              okButtonProps={{
    style: {
      backgroundColor: 'red',
      // backgroundColor: color.themeConfig.colorPrimary,
      borderColor: color.themeConfig.colorPrimary,
      color: '#fff',
    },
  }}
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm> */}
            {/* <div style={{ '--confirm-ok-color': 'red' }}> */}
  <Popconfirm
    title="Are you sure to delete this entry"
    icon={<QuestionCircleOutlined style={{ color: "red" }} />}
    onConfirm={() => deleteManualEntry(params.data)}
    trigger="click"
 okButtonProps={{
    className: "bg-red-600 hover:bg-red-700 text-white border-none",
  }}  >
    <Button className="text-red-500">
      <DeleteOutlined />
    </Button>
  </Popconfirm>
</div>

          // </div>
        );
      },
    },
];
  
// const rowData = [
// {
//     date: '07/01/2025',
//     solar: 45,
//     wind: 62,
//     crushing: 44,
//     tyres: 45,
//     hsd: 45,
//     sko: 443,
// },
// {
//     date: '08/01/2025',
//     solar: 34,
//     wind: 83,
//     crushing: 88,
//     tyres: 24,
//     hsd: 45,
//     sko: 443,
// },
// ];

const handleAddFormChange = (changedValues, allValues) => {
console.log(allValues)
console.log(changedValues)
// const date = new Date(allValues?.createdOn) 
// console.log(generatedISOFormatDateString(new Date (allValues?.createdOn)))

// console.log(dayjs(allValues.createdOn).format("YYYY-MM-DD HH:mm:ss"))
setData({
    ...allValues,
    createdOn: allValues.createdOn,
    // createdOn: allValues.createdOn ? generatedISOFormatDateString(new Date (allValues.createdOn)) : null,
});
// setOpen(false)
};

function removeBeforeUnderscore(str) {
  if (typeof str !== 'string') return str;
  const index = str.indexOf('_');
  return index !== -1 ? str.slice(index + 1) : str;
}
function formatDateISOWithPadding(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}T00:00:00.000Z`;
}


function transformWithCustomMasterId(sourceList) {
  const result = [];
  console.log(sourceList)
  console.log(convertToISTDateOnly(new Date(sourceList.createdOn)))
  console.log(formatDateISOWithPadding(new Date(sourceList?.createdOn)))

  for (const [key, value] of Object.entries(sourceList)) {
    if (isNaN(Number(removeBeforeUnderscore(key)))) continue; // skip keys like 'createdOn'

    const matchesExternal = externalEnergySources.some(i => `source_${i.sourceID}` === key);
    const matchesProduction = productionData.some(i => `production_${i.productionDataID}` === key);

    const masterID = matchesExternal
      ? 1
      : matchesProduction
      ? 2
      : 3;

    result.push({
      "masterID":masterID,
      "sourceID": parseInt(removeBeforeUnderscore(key)),
      "manualEntryValue": parseInt(value),
      "createdOn": formatDateISOWithPadding(new Date(sourceList?.createdOn)),
      // "createdOn": convertToISTDateOnly(new Date(sourceList?.createdOn)),

    });
  }

  return result;
}
 useEffect(()=>{
  GetManualData()
 },[dates,refetch])

 function setTimeToMidnight(dateString) {
  const date = new Date(dateString);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd} 00:00:00`;
}
  const GetManualData = (data) => {
    console.log(dates) 
    console.log(data);  
    const original = setTimeToMidnight(dates[0]);
    console.log(original)
    console.log(generatedISOFormatDateString(new Date(dates[0])))
      console.log(formatDateISOWithPadding(new Date(dates[0])))

    makeRequest({  
      type: APIConstants.GET,
      url: `${APIConstants.GET_MANUAL_ENTRY_DATA}?fromDate=${formatDateISOWithPadding(new Date(dates[0]))}&toDate=${formatDateISOWithPadding(new Date(dates[1]))}`,
      body: data,
    }).then((res) => {
      console.log("Master details :", res);
      if (res && res.length > 0) {
        setRow(res);
        // setFlowSectionList(res);
      }else{
        setRowEntry([]);
      }
    });
  };
  function convertToISTDateOnly(utcDateString) {
  const dateUTC = new Date(utcDateString);

  // IST is UTC +5:30 => 19800 seconds => 19800000 milliseconds
  const istOffset = 5.5 * 60 * 60 * 1000;
  const dateIST = new Date(dateUTC.getTime() + istOffset);

  const yyyy = dateIST.getFullYear();
  const mm = String(dateIST.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const dd = String(dateIST.getDate()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}`;
}


console.log(externalEnergySources);
const handleAddFormSubmit = async () => {
  console.log(data.createdOn);
  console.log(convertToISTDateOnly(new Date(data.createdOn)));
  const date = convertToISTDateOnly(new Date(data.createdOn));
  const body = transformWithCustomMasterId(data)
  console.log(transformWithCustomMasterId(data)) 
setOpen(false)
  try {
              makeRequest({
            type: APIConstants.GET,
            url: `${APIConstants.VALIDATE_MANUAL_ENTRY}?CreatedOn=${date }`,
          }).then((res) => {
            console.log("Master details :", res);
            console.log(res);
            if(res&& !res[0].isDateAvailable){
              const url = APIConstants.INSERT_MANUAL_ENTRY_DATA;
               makeRequest({
                type: "POST",
                url: url,
                body: body,
              });
              handleNotification( "Data added successfully!");
              handleClear();
              onClose();
              setRefetch(!refetch)
              setIsPanel1Complete(false)
              setIsPanel2Complete(false)
              setIsPanel3Complete(false)
              setIsPanel4Complete(false)
              
            }else{
              handleNotification("Data already exists for this date!");
              handleClear();
              onClose();
              setRefetch(!refetch)
              setIsPanel1Complete(false)
              setIsPanel2Complete(false)
              setIsPanel3Complete(false)
              setIsPanel4Complete(false)
              return;
            }
         
          });
  } catch (err) {
    console.error(err);
  }
};

console.log(row)
 



useEffect(() => {
  const rowData = [];
  console.log(row)

  if (row || row.length ) {
    row.forEach((item) => {
      const date = item.createdOn.split('T')[0]; // get only the date part
      let existingRow = rowData.find(row => row.date === date);
    
      console.log(item)
      if (!existingRow) {
        existingRow = { date,masterID: item.masterID };
        rowData.push(existingRow);
      }
    
      if (item.masterID === 1) {
        // External Energy Sources
        const source = externalEnergySources.find(i => i.sourceID === item.sourceID);
        if (source) {
          existingRow[source.sourceName.toLowerCase().replace(/\s+/g, '_')] = item.manualEntryValue;
        }
      } else if (item.masterID === 3) {
        const emission = resourceDetails.find(i => i.emissionDetailID == item.sourceID);
        console.log(emission)
        console.log(resourceDetails)
        if (emission) {
          existingRow[emission.emissionDetailName.toLowerCase().replace(/\s+/g, '_')] = item.manualEntryValue;
        }
      }else if (item.masterID === 2) {
    
        const production = productionData.find(i => i.productionDataID === item.sourceID);
        console.log(production)
        if (production) {
          existingRow[production.productionDataName.toLowerCase().replace(/\s+/g, '_')] = item.manualEntryValue;
        }
      }
    
      // You can add other masterIDs here similarly if needed
    });
    setRowEntry(rowData);
  }else{
    setRowEntry([]);
  }

},[row])



console.log(rowEntry) 

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_EXTERNAL_ENERGY_SOURCE}`,
    }).then((res) => {
      console.log(res);
      function addIsUpdateFlag(sourceArray) {
        return sourceArray.map((item) => ({
          ...item,
          isUpdate: false,
        }));
      }

      // Example usage:

      if (res && res.length > 0) {
        const updatedSources = addIsUpdateFlag(res); // originalSources is your input array
        console.log(updatedSources);

        setExternalEnergySources(updatedSources);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_PRODUCTION_DATA}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setProductionData(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_EMISSION_DATA}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setResourceDetails(res);
      }
    });
  }, []);
  
const validatePanel = (panelFields, allValues) => {
    return panelFields.every(field => allValues[field] !== undefined && allValues[field] !== null && allValues[field] !== "");
  };
  
  // const checkPanel1Completion = (_, allValues, setIsPanel1Complete) => {
  //   const panel1Fields = ["solar","wind"];
  //   setIsPanel1Complete(validatePanel(panel1Fields, allValues));
  //   // setShowMsg1(true)
  // };
  const checkPanel1Completion = (_, allValues, setIsPanel1Complete) => {
  const panel1Fields = externalEnergySources.map(
    (source) => `source_${source.sourceID}`
  );

  // const isComplete = validatePanel(panel1Fields, allValues);
  setIsPanel1Complete(validatePanel(panel1Fields, allValues));
};

  
  const checkPanel2Completion = (_, allValues, setIsPanel2Complete) => {
    const panel2Fields = productionData.map(
    (source) => `production_${source.productionDataID}`
  );
    setIsPanel2Complete(validatePanel(panel2Fields, allValues));
    // setShowMsg1(true)
  };
  
  const checkPanel3Completion = (_, allValues, setIsPanel3Complete) => {
    const panel3Fields =  resourceDetails.map(
    (source) => `emission_${source.emissionDetailID}`
  );
    setIsPanel3Complete(validatePanel(panel3Fields, allValues));
    // setShowMsg2(true)
  };
  const checkPanel4Completion = (_, allValues, setIsPanel4Complete) => {
    const panel4Fields = ["createdOn"];
    setIsPanel4Complete(validatePanel(panel4Fields, allValues));
    // setShowMsg3(true)
  };
  const today = dayjs();
  const startOfWeek = dayjs().weekday(0); // Sunday
  const endOfWeek = dayjs().weekday(6);   // Saturday
  const startOfLastWeek = dayjs().subtract(1, "week").weekday(0);
  const endOfLastWeek = dayjs().subtract(1, "week").weekday(6);
  const startOfMonth = dayjs().startOf("month");
  const endOfMonth = dayjs().endOf("month");
  const startOfLastMonth = dayjs().subtract(1, "month").startOf("month");
  const endOfLastMonth = dayjs().subtract(1, "month").endOf("month");
     
  const rangePresets = [
  //  { label: "Today", value: [today.startOf("day"), today.endOf("day")] },
  //  { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.subtract(1, "day").endOf("day")] },
    { label: "This Week", value: [startOfWeek, endOfWeek] },
    { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
    { label: "This Month", value: [startOfMonth, endOfMonth] },
    { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
    { label: "Last 7 Days", value: [dayjs().subtract(7, "day"), today] },
    { label: "Last 15 Days", value: [dayjs().subtract(15, "day"), today] },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "day"), today] },
    { label: "Last 90 Days", value: [dayjs().subtract(90, "day"), today] },
  ];
  
  const handleDateChange = (value) => {
    console.log(value)
    if (value) {
      const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
      const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");

      setDates([fromDate, toDate]);
      setValue([value[0], value[1]]);
    } else {
      setDates(null);
    }
  };

  console.log(rowEntry)
  console.log(row)
  console.log(columnDefs)

const exportTableToExcel = () => {
  return;
  const worksheetData = [
    [
      "Date",
      "External Energy Sources", "",  // solar, wind
      "Production Data", "",         // crushing, tyres
      "Emission Details", "",        // hsd, sko
    ],
    [
      "", "Solar", "Wind", "Crushing", "Tyres", "HSD", "SKO"
    ],
    // Actual data rows
    ["07/01/2025", 45, 62, 44, 45, 45, 443],
    ["08/01/2025", 34, 83, 88, 24, 45, 443],
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Merge headers
  worksheet['!merges'] = [
    { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },  // External Energy Sources
    { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },  // Production Data
    { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } },  // Emission Details
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Manual Entry");

  XLSX.writeFile(workbook, "Manual_Entry_Data.xlsx");
};



  console.log(isPanel1Complete)
  console.log(isPanel2Complete)
  console.log(isPanel3Complete)
  console.log(data)
  console.log(dates)

  console.log(rowEntry)
  return (
<div className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}>
  <div>
    <div className="flex justify-between items-center">
    <h2
      className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
        isdarkMode ? "text-white" : "text-black"
      }`}
    >
      Manual Entry
    </h2>
    <div className="flex gap-3 mb-2">
    <div  className="flex items-center justify-between  p-1 py-0">
      <h3 className={`${isdarkMode? "text-white":"text-black"}  mt-1`}>Select Date Range:</h3>
      <RangePicker
          presets={rangePresets} 
          value={value}
          // showTime={{ format: "HH:mm" }} // Enables time selection
          format="YYYY-MM-DD "
          onChange={handleDateChange}
          className={`${!isdarkMode? "customRangePicker-light":"customRangePicker-dark "}    w-[300px] ml-2  border border-white `} 
        />
    </div>
    <Button type="primary" onClick={exportTableToExcel}>
  Export to Excel
</Button>

    <Button type="primary" onClick={() => showDrawer()}>Add +</Button>
    </div>
    </div>
 
    <div className="flex gap-4 h-[80vh]">
  <Card
  className={`w-full overflow-hidden  rounded-md shadow ${isdarkMode ? 'bg-transparent' : 'bg-white'}`}
  bodyStyle={{ padding: 0 }}
>
  <div
    className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
    style={{
      '--ag-header-background-color': color.themeConfig.colorPrimary,
      '--ag-header-foreground-color': '#fff',
      '--ag-header-group-bg': color.themeConfig.colorPrimaryShade, // custom var
      height: "80vh", width: "100%", overflowY: "auto"
    }}
    
  >
    <AgGridReact
      columnDefs={columnDefs}
      rowData={rowEntry}
      domLayout="normal"
      headerHeight={50}
      rowHeight={50}
    />
  </div>
</Card>
</div>

  </div> 

  <CustomThemeDrawer
  title="Close"
  showDrawer={showDrawer}
  open={open}
  onClose={onClose}
>
  <Form
    form={form}
    onFinish={handleAddFormSubmit}
    layout="vertical"
    className="flex flex-col gap-6 mt-2 overflow-y-auto pb-24"
    onValuesChange={(_, allValues) => {
        checkPanel1Completion(_, allValues, setIsPanel1Complete);
        checkPanel2Completion(_, allValues, setIsPanel2Complete);
        checkPanel3Completion(_, allValues, setIsPanel3Complete);
        checkPanel4Completion(_, allValues, setIsPanel4Complete);
        handleAddFormChange(_, allValues);
      }}
  >
    {/* External Energy Sources */}
  
<Collapse
  className={`
    ${isPanel1Complete ? 'border-green-400' : 'border-red-400'}
    border-l-4 border-t-0 rounded-xl transition-all
    ${isdarkMode ? 'dark-collapse' : 'light-collapse'}
  `}
>
  <Panel
    header="External Energy Sources"
    key="1"
    className={`${isdarkMode ? 'bg-[#1a1a1a] text-white' : 'text-black'}`}
  >
    <div className="flex flex-col md:flex-row flex-wrap gap-4">
      {externalEnergySources.map((source) => (
        <Form.Item
          key={source.sourceID}
          label={source.sourceName}
          name={`source_${source.sourceID}`}
          rules={[{ required: true, message: `Please enter value for ${source.sourceName}` }]}
          initialValue=""
          className="w-full md:w-[45%]"
        >
          <Input
            placeholder={`Enter ${source.sourceName} value`}
            className={`${isdarkMode ? 'darkmode-input' : ''}`}
          />
        </Form.Item>
      ))}
    </div>
  </Panel>
</Collapse>



    {/* Production Data */}
    <Collapse 
    className={`
      ${isPanel2Complete ? 'border-green-400' : 'border-red-400'}
      border-l-4 border-t-0 rounded-xl transition-all
      ${isdarkMode ? 'dark-collapse' : 'light-collapse'}
    `}
    >
      <Panel header="Production Data" key="2">
            <div className="flex flex-col md:flex-row flex-wrap gap-4">
      {productionData.map((production) => (
        <Form.Item
          key={production.productionDataID}
          label={production.productionDataName}
          name={`production_${production.productionDataID}`}
          rules={[{ required: true, message: `Please enter value for ${production.productionDataName}` }]}
          initialValue=""
          className="w-full md:w-[45%]"
        >
          <Input
            placeholder={`Enter ${production.productionDataName} value`}
            className={`${isdarkMode ? 'darkmode-input' : ''}`}
          />
        </Form.Item>
      ))}
    </div>
      </Panel>
    </Collapse>

    {/* Emission Details */}
    <Collapse  className={`
    ${isPanel3Complete ? 'border-green-400' : 'border-red-400'}
    border-l-4 border-t-0 rounded-xl transition-all
    ${isdarkMode ? 'dark-collapse' : 'light-collapse'}
  `}>
      <Panel header="Resource Details" key="3">
                    <div className="flex flex-col md:flex-row flex-wrap gap-4">
      {resourceDetails.map((emission) => (
        <Form.Item
          key={emission.emissionDetailID}
          label={emission.emissionDetailName}
          name={`emission_${emission.emissionDetailID}`}
          rules={[{ required: true, message: `Please enter value for ${emission.emissionDetailName}` }]}
          initialValue=""
          className="w-full md:w-[45%]"
        >
          <Input
            placeholder={`Enter ${emission.emissionDetailName} value`}
            className={`${isdarkMode ? 'darkmode-input' : ''}`}
          />
        </Form.Item>
      ))}
    </div>
      </Panel>
    </Collapse>
    {/* CreateOn Details */}
    <Collapse  className={`
    ${isPanel4Complete ? 'border-green-400' : 'border-red-400'}
    border-l-4 border-t-0 rounded-xl transition-all
    ${isdarkMode ? 'dark-collapse' : 'light-collapse'}
  `}>
    <Panel  key="5" header={
        <div className="flex items-center">
          Created On
        </div>
      }>
          <Form.Item label="Created On" name="createdOn" rules={[{ required: true }]}><DatePicker  className={`  ${isdarkMode ? "datebackground dateplaceholder" : "whitemode"} w-80 `}
              dropdownClassName={isdarkMode ? "datedropdown" : "whitemode"} format="YYYY-MM-DD"
              //  showTime 
              popupClassName="custom-picker"
              // onChange={handleDateChange}
               />
               </Form.Item>
      
      </Panel>
    </Collapse>

    {/* Footer Buttons */}
    <div className="flex justify-between gap-4 w-full absolute bottom-0 right-0 p-4">
      <Button onClick={handleClear}>Cancel</Button>
      <Button htmlType="submit" type="primary" >
        Add
      </Button>
    </div>
  </Form>
</CustomThemeDrawer>
 

  <CustomThemeDrawer
   title="Close"
   showDrawer={showDrawer2}
   open={open2}
   onClose={onClose2}
  >
    <div className="flex flex-col gap-6 mt-2">
        <div>
          <label className="block mb-2 font-medium">
           Add Production Data
          </label>
          <Input
            placeholder="Enter Production Data.."
            // value={alertName}
            // onChange={(e) => setAlertName(e.target.value)}
            className={`${isdarkMode ? 'darkmode-input' : ''}  bg-red-500`}
          />
        </div>

        <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
          <Button onClick={onClose} className="">
            Cancel
          </Button>
          <Button
            type="primary"
            // disabled={!alertName.trim()}
            // onClick={handleAdd}
          >
            Add
          </Button>
        </div>
      </div>
  </CustomThemeDrawer>
</div>

  );
};

export default ManuallyEnteredData;


// <CustomThemeDrawer
//   title="Close"
//   showDrawer={showDrawer}
//   open={open}
//   onClose={onClose}
// >
//   <div className="flex flex-col gap-6 mt-2 overflow-y-auto ">

//     {/* External Energy Sources */}
//     <Collapse className='border-l-4 border-red-400 border-t-0'>
//       <Panel header="External Energy Sources" key="1">
//         <div className="flex  gap-4">
//           <div>
//             <label className="text-sm font-medium">Solar</label>
//             <Input placeholder="Enter Solar value" defaultValue="23" />
//           </div>
//           <div>
//             <label className="text-sm font-medium">Wind</label>
//             <Input placeholder="Enter Wind value" defaultValue="23" />
//           </div>
//         </div>
//       </Panel>
//     </Collapse>

//     {/* Production Data */}
//     <Collapse className='border-l-4 border-red-400 border-t-0'>
//       <Panel header="Production Data" key="2">
//         <div className="flex flex-col gap-2">
//           <label className="text-sm font-medium">Production</label>
//           <Input placeholder="Enter Production Data" />
//         </div>
//       </Panel>
//     </Collapse>

//     {/* Emission Details */}
//     <Collapse className='border-l-4 border-red-400 border-t-0'>
//       <Panel header="Emission Details" key="3">
//         <div className="flex flex-col gap-2">
//           <label className="text-sm font-medium">Emissions</label>
//           <Input placeholder="Enter Emission Details" />
//         </div>
//       </Panel>
//     </Collapse>

//     {/* Footer Buttons */}
//     <div className="flex justify-between gap-4 w-full absolute bottom-0 right-0 p-4 bg-white">
//       <Button onClick={onClose}>Cancel</Button>
//       <Button type="primary">Add</Button>
//     </div>
//   </div>
// </CustomThemeDrawer>